<template>
  <transition name="fade2-right">
    <div class="MessageBoxVueWrap">
      <div class="MessageBoxVueBox">
        <div class="top">
          <h2>{{ mObj.title }}</h2>
          <span class="time">{{ mObj.createDate }}</span>
        </div>
        <div class="center">
          <quill-editor
            :disabled="true"
            v-model="mObj.content"
            :options="quillOptions"
          ></quill-editor>
        </div>
        <div class="bottom">
          <span class="close" @click="closeBox"> 关闭 </span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { defineEmits, defineProps, onMounted, ref } from "vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import notice from "@/api/notice";
const emit = defineEmits(["closeBox"]);
const closeBox = () => {
  emit("close");
};
const quillOptions = ref({
  modules: {
    toolbar: false,
  },
});

const mObj = ref({});
const getData = async () => {
    notice.openwebtermsofserviceInfo(props.messageData.id).then(res=> {
        console.log(res)
        if(res.code ===0) {
            mObj.value = res.data;
        }
    })
};
const props = defineProps({
  messageData: Object,
});
onMounted(()=>{
    getData()
})
</script>

<style lang="scss" scoped>
.MessageBoxVueWrap {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.4);
  z-index: 99999;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  animation: fadeIn 0.5s ease;

  .MessageBoxVueBox {
    width: 800px;
    max-width: 100%;
    min-height: 400px;
    padding: 50px 40px 20px;
    border-radius: 10px;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .top {
      display: flex;
      padding-bottom: 30px;
      border-bottom: 1px solid #999;
      h2 {
        flex: 1;
      }
      .time {
        display: inline-block;
        padding: 5px 10px;
        color: #999;
      }
    }

    .center {
      min-height: 300px;

      p {
        padding: 20px 0;
      }
    }

    .bottom {
      text-align: right;
      span {
        display: inline-block;
        padding: 5px 15px;
        border-radius: 3px;
        cursor: pointer;
        border: 1px solid rgba($color: #000000, $alpha: 0.2);
      }
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fade2-right-leave-active {
  transition: opacity 0.5s ease;
}

.fade2-right-leave-to {
  opacity: 0;
}
</style>